import React from 'react';
import styles from './ViewAdButton.module.scss';
import {IProduct} from 'data/interfaces/products';
import LinkBlock from 'gui/components/linkBlock/LinkBlock';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {generateSluggedAdUrl} from 'data/redux/actions/guiActions';
import {Tooltip} from '@material-ui/core';
import CircleLoader from '../circleLoader';

interface IViewAdButtonProps {
  product: IProduct;
  className?: string;
  href?: string;
  loading?: boolean;
}


const ViewAdButton = ({loading, ...props}: IViewAdButtonProps) => loading ? <CircleLoader/> : (
  <LinkBlock to={props.href || generateSluggedAdUrl(props.product)}
             className={`${styles.controlButton} ${props.className}`}>
    <Tooltip title="צפיה" aria-label="view" arrow enterDelay={0}>
      <VisibilityIcon/>
    </Tooltip>
  </LinkBlock>
);

ViewAdButton.defaultProps = {
  product: {},
  className: ''
};
export default ViewAdButton;
